export default "__VITE_ASSET__CF77Ijq3__"